import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import timeclockInstance from '../../config/timeclockInstance';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import DialogTitle from '@material-ui/core/DialogTitle';
import moment from 'moment';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import Input from '../../components/Input/Input';
import Camera from '../../components/Camera/Camera';
import RunningTime from '../../components/RunningTime/RunningTime';
import { fetchUser, clockInOut, sendEmail, clockInOutNew } from '../../store/actions/clockInOut';
import ConfirmDialog from './../../components/ConfirmDialog/ConfirmDialog';
import { Receipt } from '../../components/TimeclockReceipt/TimeclockReceipt';
import DuplicatedPoint from '../../containers/ClockInOut/DuplicatePoint';

import Geolocation from '@react-native-community/geolocation'
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { SetMealSharp } from '@mui/icons-material';
import { Snackbar } from '@material-ui/core';
import { Alert } from '@mui/material';

const jwt = require('jsonwebtoken');
const fpPromise = FingerprintJS.load()

const styles = theme => ({
  itemContainer: {
    paddingTop: 10,
  },
  modalPadding: {

    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',

  },
  formPonto: {
    paddingLeft: 50,
    paddingRight: 50,
    paddingBottom: 50,
  },
  itemTitle: {
    color: '#8898AA',
  },
  button: {
    borderRadius: '100px',
    margin: theme.spacing(2),
  },
  buttonRegister: {
    border: '1px solid',
    borderColor: theme.palette.grey[300],
    fontSize: '0.75rem',
    '&:hover': {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
    },
  },
  buttonClock: {
    color: '#fff',
    width: '150px',
    padding: `${theme.spacing(2)}px ${theme.spacing(6)}px`,
    marginLeft: '50px',
  },
  in: {
    backgroundColor: '#61bb47',
    '&:hover': {
      backgroundColor: '#2b8a15',
    },
  },
  out: {
    backgroundColor: '#e03a3d',
    '&:hover': {
      backgroundColor: '#a70016',
    },
  },
  link: {
    color: '#ACACAC',
    textDecoration: 'none',
    '&:hover': {
      color: '#537ccd',
    },
  },
});

function Ponto(props) {
  const auth = useSelector(state => state.auth);
  const loading = useSelector(state => state.general.loading);
  const decodedToken = jwt.decode(auth.token);

  const { classes, name } = props;
  const { onClose, selectedValue, ...other } = props;
  const [open, setOpen] = React.useState(false);
  const [isChecked, setIsChecked] = React.useState(false);
  const [companyId, setCompanyId] = React.useState(null);
  const [company, setCompany] = React.useState(null);
  const [justification, setJustificatory] = React.useState(null);
  const [password, setPassword] = React.useState('');
  const [data, setData] = React.useState(null);
  const [openDuplicated, setOpenDuplicated] = React.useState(false);
  const [companies, setCompanies] = React.useState(null);
  const [newData, setNewData] = React.useState(null);
  const [newDataChanged, setNewDataChange] = React.useState(null);
  const [disableButton, setDisableButton] = React.useState(false);
  const [messageError, setMessageError] = React.useState('')
  const [openMessageError, setOpenMessageError] = React.useState(false)

  const [lat, setLat] = React.useState(-20.361736);
  const [lng, setLng] = React.useState(-46.919249);
  const [camera, setCamera] = React.useState(null);
  const [VisitorId, setVisitorId] = React.useState('')

  const dispatch = useDispatch();

  const handleFetchUser = () => {
    dispatch(fetchUser(decodedToken.cpf))
      .then((response) => {
        setCompany(response.companies.length && response);
        setCompanyId(response.companies.length && response.companies[0].id);
        if (response.companies.length && response.companies[0].id) {
          Visitor(response.companies[0].id);
        }
      })
      .catch(error => error);
  };

  function Visitor(companyId) {
    fpPromise
      .then(fp => fp.get())
      .then(result => {
        // This is the visitor identifier:
        // const visitorId = result.visitorId;
        setVisitorId(result.visitorId + companyId);
      })
      .catch(error => console.error(error))
  };

  function handleClose() {
    onClose(selectedValue);
    setCamera(null);
  }

  const registerWebTimeclock = async (data) => {
    try {
      if (decodedToken.cpf) {
        setDisableButton(false);
        dispatch(clockInOutNew(data, auth.token))
          .then((result) => {
            if (result == 'Senha inválida.') {
              setMessageError(result)
              setOpenMessageError(true)
              return;
            }
            setCompanyId(null);
            setData(result);
            setOpen(true);

          })
          .catch(error => {
            setDisableButton(false);
          });
      }
    } catch (error) {
      console.log(error)
    }
  };

  React.useEffect(() => {
    handleFetchUser();

    // const options = {  ** Atenção ficará comentado por enquanto como exemplo futuro!
    //   timeout: 5000,
    //   maximumAge: 1000,
    //   enableHighAccuracy: false
    // };
    // console.log(options)

    // fetch('http://ip-api.com/json')
    //   .then(response => response.json())
    //   .then(data => {
    //     console.log('segundo', data);
    //     const lat = data.lat;
    //     const lng = data.lon;
    //     // Use lat e lng para exibir a localização no mapa, por exemplo.
    //   })
    //   .catch(error => {
    //     console.error(error);
    //   });

    if (Geolocation) {
      Geolocation.getCurrentPosition(
        (position) => {
          console.log(position)
          setLat(position.coords.latitude);
          setLng(position.coords.longitude);
        },
        (error) => {
          console.log(error)
        },
        { enableHighAccuracy: false, maximumAge: 1000, timeout: 5000 }
        // options,
      );
    }
  }, []);

  const handleClock = (type) => {
    setDisableButton(true);
    const dataClock = {
      companyId,
      lat,
      lng,
      password,
      cpf: decodedToken.cpf,
      deviceId: VisitorId,
      type,
      dtRegister: moment().format('YYYY-MM-DD HH:mm:ss'),
      photoBase64: camera.takePicture(),
      employeeObs: justification,
    };
    const change = type === 'I' ? 'I' : 'O';
    setNewData({ ...dataClock, type: 'I' });
    setNewDataChange({ ...dataClock, type: 'O' });

    registerWebTimeclock(dataClock);
  };

  const handleChange = name => (event) => {
    setPassword(event.target.value);
  };

  const handleChangeJust = name => (event) => {
    setJustificatory(event.target.value);
  };

  const onCloseReceipt = () => {
    setOpen(false);
    onClose(true);
    setIsChecked(true);
    window.location.reload();
  };

  const onSendEmail = () => {
    dispatch(sendEmail(data.id, auth.token));
    setOpen(false);
    onClose(true);
    setIsChecked(true);
    window.location.reload();
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      {...other}
      PaperProps={{
        style: {
          borderRadius: 20,
          // justifyContent:'center',
          alignItems: 'center'
        }
      }}

    >
      <DialogTitle>Bater Ponto</DialogTitle>
      <div >
        <div className={classes.modalPadding}>
          <Typography
            variant="body1"
            color="textSecondary"
            paragraph
          >
            {name}
          </Typography>
          <Camera
            innerRef={(node) => {
              setCamera(node);
            }}
          />
          <RunningTime />
        </div>
        <div className={classes.formPonto} >
          <div>
            <Input
              elementType="justificatory"
              label="Justificativa (Opcional):"
              margin="normal"
              onChange={handleChangeJust()}
              fullWidth
            />
            <Input
              elementType="passwordToggle"
              name="password"
              label="Senha"
              margin="normal"
              onChange={handleChange()}
              required
              fullWidth
            />
          </div>
          <Typography paragraph variant="caption" align="right">
            <Link
              to={{ pathname: '/esqueceu-senha', state: { returnLink: '/ponto-web' } }}
              className={classes.link}
              target="_blank"
            >
              esqueceu sua senha?
            </Link>
          </Typography>
          {loading ? <CircularProgress color="primary" /> : (
            <div>
              <Button
                variant="contained"
                onClick={() => handleClock('I')}
                className={classNames(classes.button, classes.buttonClock, classes.in)}
                disabled={disableButton}
              >
                ENTRADA
              </Button>
              <Button
                variant="contained"
                disabled={disableButton}
                onClick={() => handleClock('O')}
                className={classNames(classes.button, classes.buttonClock, classes.out)}
              >
                SAÍDA
              </Button>
              <Typography style={{
                opacity: 0.4,
                textAlign: 'center'
              }}>
                ID do Aparelho: {VisitorId}
              </Typography>
            </div>)
          }
        </div>
        <Typography style={{ textAlign: 'center', opacity: 0.3, fontSize: '12px' }}>Versão 1.0.0</Typography>
      </div>

      <Snackbar
        open={openMessageError}
        autoHideDuration={3000}
        onClose={() => setOpenMessageError(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} // Adicionei esta linha
      >
        <Alert onClose={() => setOpenMessageError(false)}
          severity="error"
          sx={{ width: '100%', backgroundColor: 'white', color: 'red' }}
        >
          Senha errada, tente novamente !
        </Alert>
      </Snackbar>
      <DuplicatedPoint
        open={openDuplicated}
        companies={companies}
        disabled={disableButton}
        dtRegister={companies && moment(companies.refDate).locale('pt-br')}
        handleDuplicateIn={() => {
          setDisableButton(true);
          dispatch(clockInOutNew(newData, auth.token))
            .then((result) => {
              setCompanyId(null);
              setData(result);
              setOpen(true);
              setOpenDuplicated(false);
            })
            .catch(error => {
              setDisableButton(false);
              setOpenDuplicated(false);
            });
        }}
        handleDuplicateOut={() => {
          setDisableButton(true);
          dispatch(clockInOutNew(newDataChanged, auth.token))
            .then((result) => {
              setCompanyId(null);
              setData(result);
              setOpen(true);
            })
            .catch(error => {
              setDisableButton(false);
              setOpenDuplicated(false);
            });
        }}


      />
      <ConfirmDialog
        open={open}
        title="Ponto registrado com sucesso"
        confirmText="Enviar por email"
        closeText="FECHAR"
        onClose={onCloseReceipt}
        onConfirm={onSendEmail}
        data={data}
        company={company}
        user={{ employeeName: name }}
        dtRegister={new Date()}
        content={(
          <Receipt
            data={data}
            user={company}
            // checked={verifyCheck}
            company={company ? company.companies : []}
          />
        )}
      />

    </Dialog >
  );
}

Ponto.propTypes = {
  onClose: PropTypes.func,
  selectedValue: PropTypes.string,
};

export default (withStyles(styles)(Ponto));

